@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply inline-flex;
  }
}
